var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastheadCircleClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 38,
    height: 38,
    rx: 19,
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0469 20L26.875 15.2188L27.8594 14.2344C28 14.0938 28 13.8594 27.8594 13.6719L26.8281 12.6406C26.6406 12.5 26.4062 12.5 26.2656 12.6406L20.5 18.4531L14.6875 12.6406C14.5469 12.5 14.3125 12.5 14.125 12.6406L13.0938 13.6719C12.9531 13.8594 12.9531 14.0938 13.0938 14.2344L18.9062 20L13.0938 25.8125C12.9531 25.9531 12.9531 26.1875 13.0938 26.375L14.125 27.4062C14.3125 27.5469 14.5469 27.5469 14.6875 27.4062L20.5 21.5938L25.2812 26.4219L26.2656 27.4062C26.4062 27.5469 26.6406 27.5469 26.8281 27.4062L27.8594 26.375C28 26.1875 28 25.9531 27.8594 25.8125L22.0469 20Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastheadCircleClose);
export default __webpack_public_path__ + "static/media/masthead-circle-close.5935d34c728fe8b3fda8254329e0c485.svg";
export { ForwardRef as ReactComponent };